<template>
  <div class="users-list-view">
    <top-bar
      title="Usuarios"
      :show-add-button="true"
      add-button-label="Añadir Usuario"
      @addItem="$router.push({name: 'users-create'})"
    />
    <scrollable-container>
      <div class="padding-20">
        <ms-grid
          :data="items"
          :columns="columns"
          :options="options"
          :pager="pager"
        >
          <router-link
            slot-scope="{row}"
            slot="firstName"
            :to="{name:'users-edit', params:{id:row.id}}"
          >{{ row.firstName + ' ' + row.secondName }}
          </router-link>
        </ms-grid>
      </div>
    </scrollable-container>
  </div>
</template>

<script>
import DefaultGuards from '@/guards/default.guards'
import DefaultActions from '@/helpers/default-actions'
import TopBar from '@/components/top-bar'
import ScrollableContainer from '@/components/scrollable-container'
import MsGrid from '@/modules/grid/ms-grid'
import { mapGetters } from 'vuex'
import roleFilter from '@/filters/role.filter'

export default {
  name: 'UsersListView',
  components: {
    TopBar,
    ScrollableContainer,
    MsGrid
  },
  data () {
    return {
      columns: [
        {
          label: 'ID',
          property: 'id',
          align: 'center'
        },
        {
          label: 'Nombre',
          property: 'firstName'
        },
        {
          label: 'Apellido Paterno',
          property: 'lastName'
        },
        {
          label: 'Apellido Materno',
          property: 'maidenName'
        },
        {
          label: 'Email',
          property: 'email'
        },
        {
          label: 'Rol',
          property: 'role',
          filter: roleFilter
        },
        {
          label: 'Creado',
          property: 'createdAt',
          type: 'dateTime'
        }
      ],
      options: {
        selectable: false,
        actions: [DefaultActions.edit('users'), DefaultActions.delete('users')]
      }
    }
  },
  computed: {
    ...mapGetters('users', {
      items: 'items',
      pager: 'pagination'
    })
  },
  methods: {
    randomStar () {
      return Math.ceil(Math.random() * 5)
    }
  },
  beforeRouteEnter: DefaultGuards.onQuery('users', {}, [
    'firstName',
    'lastName',
    'maidenName'
  ]),
  beforeRouteUpdate: DefaultGuards.onQuery('users', {}, [
    'firstName',
    'lastName',
    'maidenName'
  ])
}
</script>

<style scoped>
.dealer-list {
  max-height: 100%;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/views/app/users/users-list-view.vue